import FunctionAssignerButtons from "./FunctionAssignerButtons";

export default FunctionAssignerButtons;
